export default "__VITE_ASSET__DIQ4b2Il__"